import React from "react";

const Dot = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    aria-hidden="true"
    className="opacity-80"
  >
    <rect x="1" y="1" width="8" height="8" rx="1.5" fill="none" stroke="#F5F0E8" strokeWidth="1" />
  </svg>
);

const CredibilityStrip = () => {
  const items = [
    "Built for Hong Kong",
    "Cantonese Mahjong",
    "Powered by Claude AI",
    "Coming to SGV & beyond",
  ];
  return (
    <section
      data-testid="credibility-strip"
      className="bg-jade-felt text-[#F5F0E8] border-y border-[#2E5C44]"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-4 md:py-5">
        <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 md:gap-x-10 text-[11px] md:text-xs uppercase tracking-[0.22em] font-medium">
          {items.map((item, i) => (
            <li key={item} className="flex items-center gap-3">
              <span>{item}</span>
              {i < items.length - 1 && <Dot />}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CredibilityStrip;
